import React from 'react';
import { AddressSuggestionsDocument, AddressSuggestionsQuery, AddressSuggestionsQueryVariables } from 'shared/generated.graphql';
import { useClient } from 'urql';


export const useAddressSuggestions2025Func = (): (query: string) => Promise<string[]> => {
  const client = useClient();
  const fetchSuggestions = async (userInput: string) =>  {
    const {data, error} = await client.query<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>(AddressSuggestionsDocument, {userInput}).toPromise();
    if (error) {
      console.error(`Error fetching address suggestions:`, error);
      return [];
    };
    return (data?.addressSuggestions ?? []) as string[];
  }
  return React.useCallback(fetchSuggestions, [client]);
}
